(function () {
  'use strict';

  function setAccordionItemState(item, isOpen) {
    var toggle = item.querySelector('[data-sd-product-accordion-toggle]');
    var panel = item.querySelector('[data-sd-product-accordion-panel]');

    if (!toggle) {
      return;
    }

    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    panel?.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    item.classList.toggle('is-open', isOpen);
  }

  function initProductAccordionItem(item) {
    if (!item || item.dataset.sdProductAccordionInitialized === 'true') {
      return;
    }

    var toggle = item.querySelector('[data-sd-product-accordion-toggle]');
    var panel = item.querySelector('[data-sd-product-accordion-panel]');

    if (!toggle || !panel) {
      return;
    }

    item.dataset.sdProductAccordionInitialized = 'true';
    setAccordionItemState(item, false);

    toggle.addEventListener('click', function () {
      var isOpen = toggle.getAttribute('aria-expanded') === 'true';
      setAccordionItemState(item, !isOpen);
    });
  }

  function initProductAccordions(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-sd-product-accordion-item]').forEach(initProductAccordionItem);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initProductAccordions();
    });
  } else {
    initProductAccordions();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initProductAccordions(event.target);
  });
})();
